import styled from 'styled-components';
import {UsefulLinksListDefaultBox} from './useful-links-list.default.box';

export const UsefulLinksListCasino777Box = styled(UsefulLinksListDefaultBox)`
    background: none;
`;